import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOffRounded';
import VisibilityIcon from '@mui/icons-material/VisibilityRounded';

function formatDate(value) {
    if (!value) {
        return 'Never'
    }
    return new Date(value).toLocaleString()
}

function isHidden(row) {
    return Boolean(row.is_hidden)
}

export default function TeamTable(props) {
    const hiddenCount = (props.items ?? []).filter(isHidden).length

    return (
        <Stack spacing={1}>
            <Typography variant="h6" gutterBottom>
                <Stack spacing={3} direction="row" alignItems="end">
                    <div>
                        Total freelancers: {props.items?.length ?? 0}
                        {hiddenCount ? ` (${hiddenCount} hidden)` : ''}
                    </div>
                    {props.headerContent}
                </Stack>
            </Typography>
            <TableContainer component={Paper}>
                <Table size="small" sx={{ minWidth: 650 }} aria-label="team table">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ width: 60 }} />
                            <TableCell align="left">Name</TableCell>
                            <TableCell align="left">Upwork Title</TableCell>
                            <TableCell align="center" sx={{ width: 110 }}>Job Success</TableCell>
                            <TableCell align="center" sx={{ width: 130 }}>Status</TableCell>
                            <TableCell align="center" sx={{ width: 90 }}>Jobs</TableCell>
                            <TableCell align="left" sx={{ width: 180 }}>Last Synced</TableCell>
                            {props.isAdmin ? <TableCell align="center" sx={{ width: 70 }}>Actions</TableCell> : null}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.items?.map((row) => (
                            <TableRow
                                hover
                                key={row.id}
                                sx={{
                                    cursor: 'pointer',
                                    opacity: isHidden(row) ? 0.55 : 1,
                                }}
                                onClick={() => { props.onOpen(row) }}
                            >
                                <TableCell>
                                    <Avatar src={row.photo_url} sx={{ width: 32, height: 32 }}>
                                        {(row.name || '?').charAt(0)}
                                    </Avatar>
                                </TableCell>
                                <TableCell align="left">{row.name}</TableCell>
                                <TableCell align="left">{row.title || '—'}</TableCell>
                                <TableCell align="center">
                                    {row.job_success_score != null ? Math.round(row.job_success_score * 100) + '%' : '—'}
                                </TableCell>
                                <TableCell align="center">
                                    <Stack direction="row" spacing={0.5} justifyContent="center" flexWrap="wrap" useFlexGap>
                                        {isHidden(row) ?
                                            <Chip size="small" label="Hidden" color="warning" />
                                        : row.top_rated_status && row.top_rated_status !== 'none' ?
                                            <Chip size="small" label={row.top_rated_status.replace('_', ' ')} color="success" />
                                        : row.activation_status === 1 ?
                                            <Chip size="small" label="Active" color="info" />
                                        :
                                            <Chip size="small" label={'Status ' + row.activation_status} color="default" />
                                        }
                                    </Stack>
                                </TableCell>
                                <TableCell align="center">
                                    {(row.total_hourly_jobs ?? 0) + (row.total_fixed_jobs ?? 0)}
                                </TableCell>
                                <TableCell align="left">{formatDate(row.synced_at)}</TableCell>
                                {props.isAdmin ?
                                <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                                    {isHidden(row) ?
                                        <Tooltip arrow title="Show profile">
                                            <IconButton
                                                size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    props.onSetVisibility(row.id, false)
                                                }}
                                            >
                                                <VisibilityIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    :
                                        <Tooltip arrow title="Hide profile">
                                            <IconButton
                                                size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    props.onSetVisibility(row.id, true)
                                                }}
                                            >
                                                <VisibilityOffIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                </TableCell>
                                : null}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Stack>
    );
}
